@let isVDR = (isVDR$ | async)!;

<section [ngClass]="{ 'overflow-hidden': isInitializeDiagnosisScreen() }">
  <div class="header">
    <app-header [diagnosisSessionId]="sessionId" [externalId]="externalId" [isVDR]="isVDR" />
  </div>
  <div class="flex flex-col overflow-auto flex-1">
    <div class="step-master rounded-xl mt-4 mx-4">
      <app-step-master [isVDR]="isVDR" />
    </div>
    <div class="flex-auto flex flex-col min-[1400px]:overflow-auto gap-4">
      <router-outlet></router-outlet>
    </div>
  </div>
</section>
